import { useState } from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { NotificationItem } from '@/components/notifications/notification-item'
import { useMarkAllRead, useMyNotifications } from '@/features/notifications/use-notifications'

const PAGE_SIZE = 20

export const NotificationsPage = () => {
  const [page, setPage] = useState(0)
  const { data, isLoading, isError } = useMyNotifications(page, PAGE_SIZE)
  const markAll = useMarkAllRead()

  const unread = data?.unreadCount ?? 0

  return (
    <div className="mx-auto max-w-2xl space-y-4 px-4 py-6 sm:px-6">
      <div className="flex items-center justify-between gap-2">
        <h1 className="text-2xl font-bold tracking-tight">Notifications</h1>
        {unread > 0 && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => markAll.mutate()}
            disabled={markAll.isPending}
          >
            {markAll.isPending ? 'Marking…' : 'Mark all as read'}
          </Button>
        )}
      </div>

      {isLoading ? (
        <div className="space-y-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-14 w-full" />
          ))}
        </div>
      ) : isError ? (
        <p className="text-destructive">Failed to load notifications.</p>
      ) : !data || data.items.length === 0 ? (
        <Card>
          <CardContent className="py-12 text-center text-sm text-muted-foreground">
            No notifications yet. When creators you subscribe to publish, you&apos;ll see it here.
          </CardContent>
        </Card>
      ) : (
        <Card>
          <CardContent className="p-0">
            {data.items.map((n) => (
              <NotificationItem key={n.id} notification={n} />
            ))}
          </CardContent>
        </Card>
      )}

      {data && data.totalPages > 1 && (
        <div className="flex items-center justify-between">
          <Button
            variant="outline"
            size="sm"
            disabled={page === 0}
            onClick={() => setPage((p) => Math.max(0, p - 1))}
          >
            Previous
          </Button>
          <span className="text-xs text-muted-foreground">
            Page {data.page + 1} of {data.totalPages}
          </span>
          <Button
            variant="outline"
            size="sm"
            disabled={page + 1 >= data.totalPages}
            onClick={() => setPage((p) => p + 1)}
          >
            Next
          </Button>
        </div>
      )}
    </div>
  )
}
